/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnitEnum } from './UnitEnum';
import {
    UnitEnumFromJSON,
    UnitEnumFromJSONTyped,
    UnitEnumToJSON,
    UnitEnumToJSONTyped,
} from './UnitEnum';

/**
 * 
 * @export
 * @interface NoticePeriodDurationDto
 */
export interface NoticePeriodDurationDto {
    /**
     * 
     * @type {number}
     * @memberof NoticePeriodDurationDto
     */
    value: number;
    /**
     * 
     * @type {UnitEnum}
     * @memberof NoticePeriodDurationDto
     */
    unit: UnitEnum;
}



/**
 * Check if a given object implements the NoticePeriodDurationDto interface.
 */
export function instanceOfNoticePeriodDurationDto(value: object): value is NoticePeriodDurationDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    return true;
}

export function NoticePeriodDurationDtoFromJSON(json: any): NoticePeriodDurationDto {
    return NoticePeriodDurationDtoFromJSONTyped(json, false);
}

export function NoticePeriodDurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoticePeriodDurationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'unit': UnitEnumFromJSON(json['unit']),
    };
}

export function NoticePeriodDurationDtoToJSON(json: any): NoticePeriodDurationDto {
    return NoticePeriodDurationDtoToJSONTyped(json, false);
}

export function NoticePeriodDurationDtoToJSONTyped(value?: NoticePeriodDurationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'unit': UnitEnumToJSON(value['unit']),
    };
}

